import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { PlansSection } from '@/features/admin/components/billing/PlansSection';
import './UpgradeModal.css';

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function UpgradeModal({ isOpen, onClose }: UpgradeModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="modal-overlay">
          <motion.div
            className="modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          <motion.div
            className="upgrade-modal"
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
            style={{ maxWidth: '1000px' }}
          >
            {/* Header */}
            <div className="upgrade-modal__header">
              <div>
                <h2 className="upgrade-modal__title">Choose your plan</h2>
                <p className="upgrade-modal__subtitle">
                  Select the plan that best fits your team's needs to unlock advanced collaboration.
                </p>
              </div>
              <button className="invite-modal__close" onClick={onClose} aria-label="Close">
                <X size={18} />
              </button>
            </div>

            {/* Plans content */}
            <div className="upgrade-modal__content">
              <PlansSection />
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
